import Vue from "vue";

import "@/plugins/config.js";
import "@/services";
import { ENDPOINTS } from "@/services/Endpoints.js";
import store from "@/store";

Vue.prototype.$dashboard = new Vue({
  data() {
    return {
      ENDPOINTS,
      faturamento_mensal: "",
      quantidade_pedidos: {},
      quantidade_produtos: {},
      quantidade_clientes: {},
      quantidade_lojas: {},
      top_produtos_vendidos: [],
      top_vendas_lojas: [],
      top_clientes_venda_mes: [],
      carregando_info_qtd_pedidos: false,
      carregando_info_qtd_produtos: false,
      carregando_info_qtd_clientes: false,
      carregando_info_qtd_lojas: false,
      carregando_info_faturamento: false,
      carregando_info_top_produtos: false,
      carregando_info_top_lojas: false,
      carregando_info_top_clientes: false,

      carregando_info_listar_evento: {},
      loadingFinalReport: false,
      eventosAtivos: [],
      eventosEncerrados: [],
      loadingEventosAtivos: false,
      loadingEventosEncerrados: false,
      loadingMore: false,
    };
  },
  computed: {
    isAdmin() {
      if (this.$axios.getLocal("oe_user_info").data.user_type === "admin")
        return true;
      return false;
    },
    locale() {
      return this.$axios.getCookie("elevenAdminLocale").substring(0, 2) || "pt";
    },
  },
  methods: {
    async getDashInfo() {
      this.carregando_info_qtd_pedidos = true;
      this.carregando_info_qtd_produtos = true;
      this.carregando_info_qtd_clientes = true;
      this.carregando_info_qtd_lojas = true;
      this.carregando_info_faturamento = true;
      this.carregando_info_top_produtos = true;
      this.carregando_info_top_lojas = true;
      this.carregando_info_top_clientes = true;
      try {
        this.getQuantidadePedidos();
        this.getQuantidadeProdutos();
        this.getQuantidadeClientes();
        this.getQuantidadeLojas();
        this.getFaturamento();
        this.getTopProdutos();
        this.getTopLojas();
        if (!this.isAdmin) {
          this.getTopClientes();
        }
      } catch (error) {
        console.error("Erro ao buscar dados:", error);
      }
    },
    getQuantidadePedidos(refresh = false) {
      this.carregando_info_qtd_pedidos = true;
      if (!sessionStorage.getItem("quantidade_pedidos") || refresh) {
        return this.$axios
          .get(this.ENDPOINTS.GET_QUANTIDADE_PEDIDOS)
          .then(response => {
            this.quantidade_pedidos = response.quantidade_pedidos;
            this.carregando_info_qtd_pedidos = false;
            sessionStorage.setItem(
              "quantidade_pedidos",
              JSON.stringify(response.quantidade_pedidos)
            );
          })
          .catch(() => {
            this.carregando_info_qtd_pedidos = false;
          });
      } else {
        const quantidade_pedidos = sessionStorage.getItem("quantidade_pedidos");
        this.quantidade_pedidos = JSON.parse(quantidade_pedidos);
        this.carregando_info_qtd_pedidos = false;
      }
    },

    getQuantidadeProdutos(refresh = false) {
      this.carregando_info_qtd_produtos = true;
      if (!sessionStorage.getItem("quantidade_produtos") || refresh) {
        return this.$axios
          .get(this.ENDPOINTS.GET_QUANTIDADE_PRODUTOS)
          .then(response => {
            this.quantidade_produtos = response.quantidade_produtos;
            this.carregando_info_qtd_produtos = false;
            sessionStorage.setItem(
              "quantidade_produtos",
              JSON.stringify(response.quantidade_produtos)
            );
          })
          .catch(() => {
            this.carregando_info_qtd_produtos = false;
          });
      } else {
        const quantidade_produtos = sessionStorage.getItem(
          "quantidade_produtos"
        );
        this.quantidade_produtos = JSON.parse(quantidade_produtos);
        this.carregando_info_qtd_produtos = false;
      }
    },

    getQuantidadeClientes(refresh = false) {
      this.carregando_info_qtd_clientes = true;
      if (!sessionStorage.getItem("quantidade_clientes") || refresh) {
        return this.$axios
          .get(this.ENDPOINTS.GET_QUANTIDADE_CLIENTES)
          .then(response => {
            this.quantidade_clientes = response.quantidade_cliente;
            this.carregando_info_qtd_clientes = false;
            sessionStorage.setItem(
              "quantidade_clientes",
              JSON.stringify(response.quantidade_cliente)
            );
          })
          .catch(() => {
            this.carregando_info_qtd_clientes = false;
          });
      } else {
        const quantidade_clientes = sessionStorage.getItem(
          "quantidade_clientes"
        );
        this.quantidade_clientes = JSON.parse(quantidade_clientes);
        this.carregando_info_qtd_clientes = false;
      }
    },

    getQuantidadeLojas(refresh = false) {
      this.carregando_info_qtd_lojas = true;
      if (!sessionStorage.getItem("quantidade_lojas") || refresh) {
        return this.$axios
          .get(this.ENDPOINTS.GET_QUANTIDADE_LOJAS)
          .then(response => {
            this.quantidade_lojas = response.quantidade_loja;
            this.carregando_info_qtd_lojas = false;
            sessionStorage.setItem(
              "quantidade_lojas",
              JSON.stringify(response.quantidade_loja)
            );
          })
          .catch(() => {
            this.carregando_info_qtd_lojas = false;
          });
      } else {
        const quantidade_lojas = sessionStorage.getItem("quantidade_lojas");
        this.quantidade_lojas = JSON.parse(quantidade_lojas);
        this.carregando_info_qtd_lojas = false;
      }
    },

    getFaturamento(refresh = false) {
      this.carregando_info_faturamento = true;
      if (!sessionStorage.getItem("faturamento_mensal") || refresh) {
        return this.$axios
          .get(this.ENDPOINTS.GET_FATURAMENTO)
          .then(response => {
            this.faturamento_mensal = response.faturamento_mensal;
            this.carregando_info_faturamento = false;
            sessionStorage.setItem(
              "faturamento_mensal",
              JSON.stringify(response.faturamento_mensal)
            );
          })
          .catch(() => {
            this.carregando_info_faturamento = false;
          });
      } else {
        const faturamento_mensal = sessionStorage.getItem("faturamento_mensal");
        this.faturamento_mensal = JSON.parse(faturamento_mensal);
        this.carregando_info_faturamento = false;
      }
    },

    getTopProdutos(refresh = false) {
      this.carregando_info_top_produtos = true;
      if (!sessionStorage.getItem("top_produtos_vendidos") || refresh) {
        return this.$axios
          .get(this.ENDPOINTS.GET_TOP_PRODUTOS)
          .then(response => {
            this.top_produtos_vendidos = response.top_produtos_vendidos;
            this.carregando_info_top_produtos = false;
            sessionStorage.setItem(
              "top_produtos_vendidos",
              JSON.stringify(response.top_produtos_vendidos)
            );
          })
          .catch(() => {
            this.carregando_info_top_produtos = false;
          });
      } else {
        const top_produtos_vendidos = sessionStorage.getItem(
          "top_produtos_vendidos"
        );
        this.top_produtos_vendidos = JSON.parse(top_produtos_vendidos);
        this.carregando_info_top_produtos = false;
      }
    },

    getTopLojas(refresh = false) {
      this.carregando_info_top_lojas = true;
      if (!sessionStorage.getItem("top_vendas_lojas") || refresh) {
        return this.$axios
          .get(this.ENDPOINTS.GET_TOP_LOJAS)
          .then(response => {
            this.top_vendas_lojas = response.top_vendas_lojas;
            this.carregando_info_top_lojas = false;
            sessionStorage.setItem(
              "top_vendas_lojas",
              JSON.stringify(response.top_vendas_lojas)
            );
          })
          .catch(() => {
            this.carregando_info_top_lojas = false;
          });
      } else {
        const top_vendas_lojas = sessionStorage.getItem("top_vendas_lojas");
        this.top_vendas_lojas = JSON.parse(top_vendas_lojas);
        this.carregando_info_top_lojas = false;
      }
    },

    getTopClientes(refresh = false) {
      this.carregando_info_top_clientes = true;
      if (!sessionStorage.getItem("top_clientes_venda_mes") || refresh) {
        return this.$axios
          .get(this.ENDPOINTS.GET_TOP_CLIENTES)
          .then(response => {
            this.top_clientes_venda_mes = response.top_clientes_venda_mes;
            this.carregando_info_top_clientes = false;
            sessionStorage.setItem(
              "top_clientes_venda_mes",
              JSON.stringify(response.top_clientes_venda_mes)
            );
          })
          .catch(() => {
            this.carregando_info_top_clientes = false;
          });
      } else {
        const top_clientes_venda_mes = sessionStorage.getItem(
          "top_clientes_venda_mes"
        );
        this.top_clientes_venda_mes = JSON.parse(top_clientes_venda_mes);
        this.carregando_info_top_clientes = false;
      }
    },
    refreshDashInfo(info) {
      switch (info) {
        case "quantidade_pedidos":
          this.getQuantidadePedidos(true);
          break;
        case "quantidade_produtos":
          this.getQuantidadeProdutos(true);
          break;
        case "quantidade_clientes":
          this.getQuantidadeClientes(true);
          break;
        case "quantidade_lojas":
          this.getQuantidadeLojas(true);
          break;
        case "faturamento_mensal":
          this.getFaturamento(true);
          break;
        case "top_produtos_vendidos":
          this.getTopProdutos(true);
          break;
        case "top_vendas_lojas":
          this.getTopLojas(true);
          break;
        case "top_clientes_venda_mes":
          this.getTopClientes(true);
          break;
        default:
          this.getDashInfo();
          break;
      }
    },
    getEventos(type = "load", page = 10, lojaSequencial = null) {
      if (store.getters.isAffiliate) return;
      const storageKey = this.$axios.getLocal("oe_user_info").data?.user_type;
      if (storageKey === "loja") {
        if (type === "load") {
          this.loadingEventosAtivos = true;
          this.loadingEventosEncerrados = true;
          this.$axios
            .post(`${this.ENDPOINTS.PRODUTOS_LISTAR_EVENTO}ativos`, {
              loja: this.$axios.getLocal("oe_user_info").data.loja,
              paginacao: page,
              lang: this.locale,
            })
            .then(response => {
              this.eventosAtivos = response;
              this.loadingEventosAtivos = false;
            });

          this.$axios
            .post(`${this.ENDPOINTS.PRODUTOS_LISTAR_EVENTO}encerrados`, {
              loja: this.$axios.getLocal("oe_user_info").data.loja,
              paginacao: page,
              lang: this.locale,
            })
            .then(response => {
              this.eventosEncerrados = response;
              this.loadingEventosEncerrados = false;
            });

          return;
        }

        if (type === "loadMore") {
          this.loadingMore = true;
          this.$axios
            .post(`${this.ENDPOINTS.PRODUTOS_LISTAR_EVENTO}ativos`, {
              loja: this.$axios.getLocal("oe_user_info").data.loja,
              paginacao: page,
            })
            .then(response => {
              this.eventosAtivos.push(...response);
              this.loadingMore = false;
            });

          this.$axios
            .post(`${this.ENDPOINTS.PRODUTOS_LISTAR_EVENTO}encerrados`, {
              loja: this.$axios.getLocal("oe_user_info").data.loja,
              paginacao: page,
              lang: this.locale,
            })
            .then(response => {
              this.eventosEncerrados.push(...response);
              this.loadingMore = false;
            });

          return;
        }
      } else {
        if (type === "load") {
          this.loadingEventosAtivos = true;
          this.loadingEventosEncerrados = true;
          this.$axios
            .post(`${this.ENDPOINTS.PRODUTOS_LISTAR_EVENTO}ativos`, {
              loja: lojaSequencial,
              paginacao: page,
              lang: this.locale,
            })
            .then(response => {
              this.eventosAtivos = response;
              this.loadingEventosAtivos = false;
            });

          this.$axios
            .post(`${this.ENDPOINTS.PRODUTOS_LISTAR_EVENTO}encerrados`, {
              loja: lojaSequencial,
              paginacao: page,
              lang: this.locale,
            })
            .then(response => {
              this.eventosEncerrados = response;
              this.loadingEventosEncerrados = false;
            });

          return;
        }

        if (type === "loadMore") {
          this.loadingMore = true;
          this.$axios
            .post(`${this.ENDPOINTS.PRODUTOS_LISTAR_EVENTO}ativos`, {
              loja: lojaSequencial,
              paginacao: page,
              lang: this.locale,
            })
            .then(response => {
              this.eventosAtivos.push(...response);
              this.loadingMore = false;
            });

          this.$axios
            .post(`${this.ENDPOINTS.PRODUTOS_LISTAR_EVENTO}encerrados`, {
              loja: lojaSequencial,
              paginacao: page,
              lang: this.locale,
            })
            .then(response => {
              this.eventosEncerrados.push(...response);
              this.loadingMore = false;
            });

          return;
        }
      }
    },
    async getFinalReport(idproduto) {
      this.loadingFinalReport = true;

      const storageKey = `finalReport-${idproduto}`;
      if (sessionStorage.getItem(storageKey)) {
        this.loadingFinalReport = false;
        return JSON.parse(sessionStorage.getItem(storageKey));
      }

      try {
        const finalReport = await this.$axios.post(
          `${this.ENDPOINTS.RESUMO_EVENTO_IDPRODUTO}${idproduto}`,
          {
            loja: this.$axios.getLocal("oe_user_info").data.loja,
          }
        );
        sessionStorage.setItem(storageKey, JSON.stringify(finalReport));
        this.loadingFinalReport = false;
        return finalReport;
      } catch (error) {
        this.loadingFinalReport = false;
        console.error("An error occurred:", error);
        throw error;
      }
    },
  },
});
